var passiveSupported = false;

if (typeof window !== 'undefined') {
  try {
    var options = Object.defineProperty({}, 'passive', {
      get: function get() {
        passiveSupported = true;
        return true;
      }
    }); // @ts-ignore

    window.addEventListener('test', options, options); // @ts-ignore

    window.removeEventListener('test', options, options);
  } catch (err) {
    passiveSupported = false;
  }
}

export var nonPassive = passiveSupported ? {
  passive: false
} : false;